var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "blog-grid grid" },
    [
      _c(
        "div",
        { staticClass: "col-12 p-0" },
        [
          _c("title-view", { attrs: { variant: "primary " } }, [
            _vm._v("\n      Bliss Blog\n    ")
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 pagination-mobile" },
        [
          _c("pagination", {
            attrs: {
              records: _vm.articles.length,
              "per-page": _vm.perPage,
              options: _vm.options
            },
            model: {
              value: _vm.page,
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          })
        ],
        1
      ),
      _vm._l(_vm.displayedRecords, function(article, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "col-4_sm-6_xs-12 article-list",
            on: {
              click: function($event) {
                return _vm.goToDetails(article.slug)
              }
            }
          },
          [
            _c(
              "blog-card-view",
              [
                _c("template", { slot: "image" }, [
                  _c("img", { attrs: { src: article.imageUrl } })
                ]),
                _c("template", { slot: "date" }, [
                  _vm._v("\n        " + _vm._s(article.date) + "\n      ")
                ]),
                _c("template", { slot: "title" }, [
                  _vm._v("\n        " + _vm._s(article.title) + "\n      ")
                ]),
                _c("template", { slot: "text" }, [
                  _vm._v("\n        " + _vm._s(article.smallTitle) + "\n      ")
                ]),
                _c("template", { slot: "tags" }, [
                  _vm._v("\n        " + _vm._s(article.tags) + "\n      ")
                ])
              ],
              2
            )
          ],
          1
        )
      }),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("pagination", {
            attrs: {
              records: _vm.articles.length,
              "per-page": _vm.perPage,
              options: _vm.options
            },
            model: {
              value: _vm.page,
              callback: function($$v) {
                _vm.page = $$v
              },
              expression: "page"
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0948cd8e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0948cd8e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/blog-grid-view.vue
// module id = 548
// module chunks = 42